/**
 * Services
 * Register Angular resource services
 *
 * @package:  frictionlessdigital/dashboard
 * @version:  2.7
 * @author:   Cyrill N KALITA
 */

require('./BudgetAllocation.js');
require('./ProgramMonthlyCosts.js');
require('./ProgramMonthlyCounts.js');
require('./ProgramSummary.js');
require('./ProgramTopSpeakers.js');
